import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

export const UNAUTHORIZED_REDIRECT_ROUTE = new InjectionToken('UNAUTHORIZED_REDIRECT_ROUTE');

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
    @Inject(UNAUTHORIZED_REDIRECT_ROUTE) private readonly _redirect: string
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return new Observable((observer) => {
      this._authService.userProfile.then((profile: any) => {
        console.log(profile);
        const expectedRoles = route.data['roles'] as string[];
        console.log('Expected roles', expectedRoles);

        if (!expectedRoles) {
          observer.next(true);
        } else {
          const set: Set<string> = new Set(profile?.info?.realm_access.roles ?? []);
          const result: boolean = expectedRoles.some(r => set.has(r));

          if (!result) {
            void this._router.navigate([this._redirect ?? '/home']);
          }

          observer.next(result);
        }
      }, (error) => {
        observer.next(false);
        void this._router.navigate([this._redirect ?? '/home']);
        console.error(error)
      });
    })
  }

}
